import api from '../api/apiClient';

/**
 * Service for managing cross-company analysis sharing
 */
export const analysisSharingService = {
  // Share an analysis with a company
  createShare: async (data) => {
    try {
      return await api.post('/analysis-shares', data);
    } catch (error) {
      console.error('Create share API error:', error);
      throw error;
    }
  },

  // Get all shared analyses
  getShares: async () => {
    try {
      return await api.get('/analysis-shares');
    } catch (error) {
      console.error('Get shares API error:', error);
      throw error;
    }
  },

  // Update a share's permission
  updateShare: async (id, data) => {
    try {
      return await api.put(`/analysis-shares/${id}`, data);
    } catch (error) {
      console.error('Update share API error:', error);
      throw error;
    }
  },

  // Delete/Revoke a share
  deleteShare: async (id) => {
    try {
      return await api.delete(`/analysis-shares/${id}`);
    } catch (error) {
      console.error('Delete share API error:', error);
      throw error;
    }
  }
};
